<mnc-product-cases-selection
  #productCasesSelectionTable
  [cases]="cases"
  [filterable]="filterable"
  [multiselect]="multiselect"
  [sortable]="sortable"
  (casesLinesSelected)="handleCasesLinesSelected($event)"
/>
